import { useParams, useNavigate } from "react-router-dom";

export default function OrderSuccess() {
  const { id } = useParams();
  const navigate = useNavigate();

  // 👇 CHANGE THIS TO YOUR BUSINESS NUMBER (include country code, no + or spaces)
  const whatsappNumber = "2348066221327";

  const message = `Hello, I just placed an order on SISI.%0AOrder ID: ${id}%0APlease confirm my order.`;
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white shadow-xl rounded-2xl p-10 max-w-md w-full text-center">

        {/* Success Icon */}
        <div className="w-20 h-20 mx-auto flex items-center justify-center bg-green-100 rounded-full mb-6">
          <i className="ri-check-line text-4xl text-green-600"></i>
        </div>

        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Payment Successful 🎉
        </h1>

        <p className="text-gray-500 mb-4">
          Your order has been placed successfully.
        </p>

        {/* Order ID */}
        <div className="bg-gray-50 rounded-lg p-4 text-sm text-gray-600 mb-6">
          Order ID:
          <div className="font-semibold text-gray-800 break-all">
            {id}
          </div>
        </div>

        {/* Buttons */}
        <div className="flex flex-col gap-3">

          {/* Continue Shopping */}
          <button
            onClick={() => navigate("/products")}
            className="w-full py-3 bg-[#EF579A] text-white rounded-xl font-semibold hover:bg-[#d94a87]"
          >
            Continue Shopping
          </button>

          {/* WhatsApp Button */}
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full py-3 bg-green-500 text-white rounded-xl font-semibold hover:bg-green-600 flex items-center justify-center gap-2"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Confirm Order on WhatsApp
          </a>

        </div>
      </div>
    </div>
  );
}
